export const checkMediaType = async (url: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      // Check the MIME type of the response to determine the media type
      const mimeType = blob?.type;

      if (mimeType.startsWith('image/')) {
        return 'image';
      } else if (mimeType.startsWith('video/')) {
        return 'video';
      } else {
        // Handle other types or unsupported media here
        console.error('Unsupported media type');
      }
    } catch (error) {
      console.error('Error loading media:', error);
    }
};